<div class="page">
  <div class="page__container">
    <h1 class="page__title h2 mb-5">{{ 'partner_payout_title' | translate }}</h1>
    <h3 style="font-weight: 500">{{ 'partner_payout_currentcredit' | translate }} {{ totalCredit }}</h3>
    <p>{{ 'partner_payout_mincredit' | translate }}</p>
    <div class="my-5">
      <h1 class="page__title h2 mb-5">{{ 'partner_payout_list_payments_title' | translate }}</h1>
      <wsb-atlas-button class="my-3" [label]="'partner_payout_mode'" (btnClick)="openModalPayout()"></wsb-atlas-button>
      <div class="my-5">
        <wsb-atlas-grid
          #grid
          class="atlas-grid-simplest"
          class="mt-2"
          [columnDefs]="tableColumnsDefs"
          [options]="tableGridOptions"
          [rowData]="tableRowData"
          [@gridIsLoaded]="gridAnimationState"
          [components]="components"
        ></wsb-atlas-grid>
        <ng-template #modalPartnerPayout let-c="close" let-d="dismiss">
          <wsb-partner-payment-modal
            (send)="modalPayoutSend($event)"
            (cancelEvent)="modalPayoutClose()"
            cancelButtonEnable="true"
            title="{{ 'partner_payout_mode' | translate }}"
          >
          </wsb-partner-payment-modal>
        </ng-template>
      </div>

      <div class="tst-info p-2 mb-1">
        <div class="d-flex">
          <img class="tst-icon" src="assets/images/icons/icon-info.svg" />
          <div>
            <div class="tst-title" translate>shop_purchase_success_title</div>
            <div class="tst-text" [innerHtml]="'partner_payout_list_payments_table_legend' | translate"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
